import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useProfileState from '@/state/profile/profileState';
import { ProfileStoreKey } from '@/models/Profile';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import BCXPaginatedContent from '@/components/molecules/BCXPaginatedContent.vue';
import SettingsIcon from '@/components/svg/settings.svg?inline';
import { isDeletedUser } from '@/utils/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMembersView',
  setup(__props) {

const { profile, canEdit } = useProfileState(ProfileStoreKey.PROFILE);
const members = computed(() => (profile.value?.company?.members ?? []).filter((member) => member.companyRole !== 'ROOT' && !isDeletedUser(member)));

return { __sfc: true,profile, canEdit, members, BCXUserBanner, BCXPaginatedContent, SettingsIcon }
}

})